import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface ChannelListLocationHeaderProps
  extends HeaderContext<
    GatewayChannelWithChargePointInfoModel,
    GatewayChannelWithChargePointInfoModel['location']
  > {}

export const ChannelListLocationHeader =
  () // props: ChannelListLocationHeaderProps,
  : ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-gateway-charge-point.location');
  };
